module.exports = __webpack_public_path__ + "img/about-patent8.d15eb85.png";